import {
    Button,
    CircularProgress,
    Container,
    Dialog,
    DialogActions,
    DialogContent,
    Typography,
} from '@material-ui/core';
import { indigo, yellow } from '@material-ui/core/colors';
import { ptBR } from '@material-ui/core/locale';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import React from 'react';
import 'typeface-roboto';
import './App.css';
import AppToolbar from './components/AppToolbar';
import { AppProvider } from './components/Context';
import Home from './components/Home';
import InterceptAxios from './components/InterceptAxios';
import logo from './logo.png';

Button.defaultProps = {
    variant: 'contained',
    color: 'primary',
};

const sidebar = createMuiTheme(
    {
        palette: {
            primary: yellow,
        },
    },
    ptBR,
);

const theme = createMuiTheme(
    {
        palette: {
            primary: indigo,
        },
    },
    ptBR,
);

const TrocaDaquiApp = () => {
    return (
        <AppProvider>
            <InterceptAxios>
                {({ error, loading, clearState }) => (
                    <>
                        <ThemeProvider theme={sidebar}>
                            <AppToolbar logo={logo} />
                        </ThemeProvider>
                        <ThemeProvider theme={theme}>
                            <Container maxWidth="md" style={{ height: '100%' }}>
                                <Home />
                            </Container>
                        </ThemeProvider>
                        <Dialog open={!!loading}>
                            <DialogContent>
                                <CircularProgress />
                            </DialogContent>
                        </Dialog>
                        <Dialog
                            open={!!error}
                            onClose={clearState}
                            style={{ zIndex: 1500 }}
                        >
                            <DialogContent
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    minHeight: '10vh',
                                    justifyContent: 'space-around',
                                }}
                            >
                                <Typography>
                                    {' '}
                                    :( Ops ocorreu um erro !
                                </Typography>
                                {error && error.message && (
                                    <Typography>{error.message}</Typography>
                                )}
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={clearState}>OK</Button>
                            </DialogActions>
                        </Dialog>
                    </>
                )}
            </InterceptAxios>
        </AppProvider>
    );
};

export default TrocaDaquiApp;
